import script from "./PdfContent.vue?vue&type=script&setup=true&lang=js"
export * from "./PdfContent.vue?vue&type=script&setup=true&lang=js"

import "./PdfContent.vue?vue&type=style&index=0&id=029ed68d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-029ed68d"]])

export default __exports__